import { Icons, Input } from '@commenda/kakashi';
import { useState } from 'react';
import {
  GroupsOnChangeHandler,
  IStateSecureInformationRequestField,
} from './types';

export const SecureInput = ({
  field,
  onChange,
  type,
}: {
  field: IStateSecureInformationRequestField;
  onChange: GroupsOnChangeHandler;
  type: 'text' | 'number';
}) => {
  const [shouldShowDots, setShouldShowDots] = useState(true);

  return (
    <div className="flex items-center gap-2">
      <div className="relative w-full">
        {/** this is a modern css feature: WebkitTextSecurity and is supported in most of our use cases */}
        <Input
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          style={shouldShowDots ? { WebkitTextSecurity: 'disc' } : {}}
          type={type}
          readOnly
          autoComplete="off"
          onFocus={(e) => e.target.removeAttribute('readonly')}
          value={field.value}
          onChange={(e) => onChange(field.id, e.target.value)}
          className="border-fg-info focus-visible:border-fg-info"
        />

        {shouldShowDots ? (
          <Icons.EyeOff
            className="absolute right-4 top-3.5 h-5 w-5 cursor-pointer text-neutral-2 hover:text-neutral-1 transition"
            onClick={() => setShouldShowDots(false)}
          />
        ) : (
          <Icons.Eye
            className="absolute right-4 top-3.5 h-5 w-5 cursor-pointer text-neutral-2 hover:text-neutral-1 transition"
            onClick={() => setShouldShowDots(true)}
          />
        )}
      </div>
      <div className="bg-neutral-7 rounded-r-lg items-center flex h-full">
        <Icons.Shield01 className="text-fg-info h-6 w-6" />
      </div>
    </div>
  );
};
